<template>
  <div class="container">
    <div class="test">
      <div class="test-header">
        <div class="btn" @click="startTest">
          {{
            isStart
              ? $t('lang.kh.choiceQuestion.sub')
              : $t('lang.kh.choiceQuestion.start')
          }}
        </div>
        <div>{{ $t('lang.kh.choiceQuestion.title') }}</div>
        <Timer :status="isStart" @time="getTime" />
      </div>
      <div class="test-content">
        <div class="test-content-title">
          <p>
            {{ $t('lang.kh.choiceQuestion.firstQ_title')
            }}<font>{{ $t('lang.kh.choiceQuestion.firstQ_title_tip') }}</font>
          </p>
        </div>
        <div class="test-content-questions">
          <div class="question" v-for="que in questions" :key="que.id">
            <p>{{ $t(que.question) }}</p>
            <el-radio-group
              v-if="que.type === 0"
              @change="changeAnswer"
              v-model="que.value"
            >
              <el-radio
                v-for="option in que.options"
                :key="option.label"
                :label="option.label"
              >
                {{ $t(option.value) }}
              </el-radio>
            </el-radio-group>

            <el-checkbox-group
              @change="changeAnswer"
              v-else
              v-model="que.value"
            >
              <el-checkbox
                v-for="option in que.options"
                :key="option.label"
                :label="option.label"
              >
                {{ $t(option.value) }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>

    <Performance
      v-show="isSubmit"
      @close="isSubmit = false"
      :data="questions"
      :score="testScore"
    />
  </div>
</template>

<script>
import { expRecord, recordInfo } from '@/api/experimentation/test'
import Timer from '@/components/experimentation/timer.vue'
import Performance from '@/components/experimentation/performance.vue'
import {lang} from '@/language/language-zh.js'
export default {
  name: 'test',
  components: { Timer, Performance },
  props: [],
  data() {
    return {
      questions: [
        {
          id: 0,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type1.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type1.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type1.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type1.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type1.options.D' },
          ],
          correct: 'B',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type2.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type2.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type2.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type2.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type2.options.D' },
          ],
          correct: 'C',
          score: 2,
          scored: 0,
        },
        {
          id: 2,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type3.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type3.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type3.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type3.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type3.options.D' },
          ],
          correct: 'A',
          score: 2,
          scored: 0,
        },
        {
          id: 3,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type4.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type4.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type4.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type4.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type4.options.D' },
          ],
          correct: 'B',
          score: 2,
          scored: 0,
        },
        {
          id: 4,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type5.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type5.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type5.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type5.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type5.options.D' },
          ],
          correct: 'B',
          score: 2,
          scored: 0,
        },
        {
          id: 5,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type6.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type6.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type6.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type6.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type6.options.D' },
          ],
          correct: 'A',
          score: 2,
          scored: 0,
        },
        {
          id: 6,
          value: [],
          type: 1,
          question: 'lang.kh.choiceQuestion.type7.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type7.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type7.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type7.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type7.options.D' },
          ],
          correct: ['AD', 'DA'],
          score: 2,
          scored: 0,
        },
        {
          id: 7,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type8.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type8.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type8.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type8.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type8.options.D' },
          ],
          correct: 'D',
          score: 2,
          scored: 0,
        },
        {
          id: 8,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type9.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type9.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type9.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type9.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type9.options.D' },
          ],
          correct: 'C',
          score: 2,
          scored: 0,
        },
        {
          id: 9,
          value: '',
          type: 0,
          question: 'lang.kh.choiceQuestion.type10.question',
          result: false,
          options: [
            { label: 'A', value: 'lang.kh.choiceQuestion.type10.options.A' },
            { label: 'B', value: 'lang.kh.choiceQuestion.type10.options.B' },
            { label: 'C', value: 'lang.kh.choiceQuestion.type10.options.C' },
            { label: 'D', value: 'lang.kh.choiceQuestion.type10.options.D' },
          ],
          correct: 'B',
          score: 2,
          scored: 0,
        },
      ],
      isStart: false,
      testTime: 0,
      isSubmit: false,
      testScore: 0,
      isAnswer: false,
      submitQue: []
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getRecord()
      let submitQue = []
      for(var key in lang.kh.choiceQuestion){
        if(key.search(/type/i) === 0) {
          submitQue.push(lang.kh.choiceQuestion[key])
        }
      }
      this.submitQue = submitQue
  },
  mounted() {},
  methods: {
    startTest() {
      this.isStart = !this.isStart
      if (!this.isStart) {
        this.submitResult()
      }
    },
    getTime(v, d) {
      this.testTime = d
    },
    changeAnswer() {
      this.isStart = true
    },
    submitResult() {
      let stepRecord = []
      this.testScore = 0
      this.questions.forEach((v, i) => {
        if (v.type == 0) {
          if (v.value == v.correct) {
            v.result = true
            v.scored = v.score
            this.testScore += v.score
          }
          stepRecord.push({
            result: v.result,
            answer: v.value,
            options: this.submitQue[i].options,
            question: this.submitQue[i].question,
            scored: v.scored,
            correct: v.correct
          })
        } else if (v.type == 1) {
          let ans = ''
          v.value.map((v) => {
            ans += v
          })
          let res = v.correct.filter((v) => v == ans)
          if (res.length) {
            v.result = true
            v.scored = v.score
            this.testScore += v.score
          }
          stepRecord.push({
            result: res.length ? true : false,
            answer: ans,
            options: this.submitQue[i].options,
            question: this.submitQue[i].question,
            scored: v.scored,
            correct: v.correct
          })
        }
      })
      this.isSubmit = true
      if (this.isAnswer) return console.log(stepRecord)
      expRecord({
        course_id: window.localStorage.getItem('expId') || 1,
        son_course_id: 31,
        stepRecord: JSON.stringify(stepRecord),
        spendSecond: this.testTime,
        expTotalScore: this.testScore,
      }).then((res) => {
        const { score } = res.data
        this.$store.commit('SET_SCORE', score)
        this.$notify({
          type: 'success',
          message: '提交成功！',
          duration: 1500,
          title: 'SUCCESS',
        })
      })
    },
    getRecord() {
      let token = window.localStorage.getItem('token')
      if (!token) return (this.isAnswer = true)
      let expId = window.localStorage.getItem('expId') || 1
      recordInfo(expId).then((res) => {
        console.log(res)
        const { record, score } = res.data
        this.$store.commit('SET_SCORE', score)
        record.forEach((v) => {
          if (v.id === 31) {
            this.isAnswer = v.me_record.length ? true : false
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 0 15%;
  color: #666666;
  .test {
    width: 100%;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 2px 24px 0px rgba(221, 241, 255, 0.49);
    border-radius: 5px;
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2vh 2.6vw;
      font-family: monospace;
      font-size: 22px;
      font-weight: bold;
      color: #444444;
      line-height: 28px;
      border-bottom: 1px solid #f7d5d5;
      .btn {
        background-color: var(--red-color);
        font-size: 18px;
      }
    }
    &-content {
      padding: 3vh 3vw;
      &-title {
        font-weight: bold;
        font {
          font-weight: normal;
          font-size: 16px;
          color: #999999;
        }
      }
      &-questions {
        width: 100%;
        height: 60vh;
        padding: 1.5vw 3vh;
        background: #ffffff;
        border: 1px solid #f0e9db;
        border-radius: 5px;
        overflow: auto;
        .question {
          height: 12vh;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          p {
            font-weight: bold;
            margin: 0;
          }
          .el-radio-group,
          .el-checkbox-group {
            display: flex;
          }
          .el-radio,
          .el-checkbox {
            display: flex;
            align-items: center;
          }
        }
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          background: rgba(174, 174, 174, 0.5);
          border-radius: 2px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 6px;
          background-color: var(--exp-color);
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>